import React from 'react'
import { Control, Controller, FieldValues, UseFormReturn } from 'react-hook-form'
import InputField from '../../../../components/common/inputs/InputField'
import { DesignData } from '../types/RoiCalculatorTypes'

interface Props {
  formControl: UseFormReturn
  name: string
  label?: string | Array<string | HTMLElement>
  infoTip?: string
  disabled?: boolean
  defaultValue?: string
  errorMessage?: string
}

const TextField: React.FC<Props> = ({
  formControl,
  name,
  label,
  infoTip,
  disabled,
  defaultValue,
  errorMessage,
}) => {
  return (
    <Controller
      name={name}
      control={formControl.control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <InputField
          errorMessage={errorMessage || formControl.formState.errors[name]?.message?.toString()}
          id={name}
          label={label}
          infoTip={infoTip}
          disabled={disabled}
          {...field}
        />
      )}
    />
  )
}

export default TextField
